import { Card, Col, Row } from 'react-bootstrap';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import certificates from 'assets/img/th-each-ai/certificates.jpg';
import received_feedback from 'assets/img/th-each-ai/received_feedback.jpg';
import give_feedback from 'assets/img/th-each-ai/give_feedback.jpg';
import PromptWidget from 'components/prompts/PromptWidgets';


const MyFeedbackDashboard = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Feedback'),
            active: true
        }
    ];
    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />
            <div className="mt-3">
                <Card className='border border-light rounded-5 mb-4' >
                    <Card.Body>
                        <div style={{ height: '100px' }} className='align-content-center '>
                            <p className="mb-0 mx-3 fs-8" style={{ 'textAlign': 'justify' }}> {t("MyFeedbackDashboard.headline")}</p>
                            <p className="mt-0 mx-3 fs-8" style={{ 'textAlign': 'justify' }}> {t("MyFeedbackDashboard.headline2")}</p>
                        </div>
                    </Card.Body>
                </Card>

                <Card className='border border-light rounded-5' >
                    <Card.Body>
                        <Row className=''>
                            <Col sm={4} md={4} lg={4}>
                                <Card onClick={() => navigate('/feedback-dashboard/received-feedbacks')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={received_feedback} />
                                    <Card.Body className='bg-theachai-tiffany'>
                                        <Card.Title className='text-white m-0 p-0 fs-6'>Request Feedback{/*t("MyFeedbackDashboard.received")*/}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={4} md={4} lg={4}>
                                <Card onClick={() => navigate('/feedback-dashboard/given-feedbacks')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={give_feedback} />
                                    <Card.Body className='bg-theachai-dark-blue'>
                                        <Card.Title className='text-white m-0 p-0 fs-6'>{t("MyFeedbackDashboard.given")}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={4} md={4} lg={4}>
                                <Card onClick={() => navigate('/feedback-dashboard/certificates')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={certificates} />
                                    <Card.Body className='bg-theachai-yellow'>
                                        <Card.Title className='text-white m-0 p-0 fs-6'>{t("MyFeedbackDashboard.certificates")}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>




                            {/* 
                            <Col sm={4} md={4} lg={4}>
                                <Card onClick={() => navigate('/feedback-dashboard/feedback-reports')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={resources} style={{ height: "200px" }} />
                                    <Card.Body className='bg-theachai-dark-blue'>
                                        <Card.Title className='text-white m-0 p-0 fs-6'>{t("MyFeedbackDashboard.reports")}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            */}

                            {/* 
                            <Col sm={12} style={{ height: '30px' }}></Col>
                            */}
                        </Row>
                    </Card.Body>
                </Card>

                <PromptWidget page="feedback" />
            </div>
        </>
    );

};

export default MyFeedbackDashboard;
